import { render, staticRenderFns } from "./SocialValue.vue?vue&type=template&id=3803d624&scoped=true&"
import script from "./SocialValue.vue?vue&type=script&lang=js&"
export * from "./SocialValue.vue?vue&type=script&lang=js&"
import style0 from "./SocialValue.vue?vue&type=style&index=0&id=3803d624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803d624",
  null
  
)

export default component.exports